/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CALL_API } from '../middleware';
import {
  ApplicationProps,
  directDistrubutorType,
  RMType,
  supportSubdistibutorDetailsType,
} from '../types/api-types';
import {
  GET_DISTRIBUTOR_CODES,
  GET_DISTRIBUTOR_CODES_SUCCESS,
  GET_IFSC_DETAILS_SUCCESS,
  GET_IFSC_DETAILS,
  GET_DISTRIBUTORS_SUCCESS,
  GET_DISTRIBUTORS,
  IfscType,
  GET_RMS,
  GET_RMS_SUCCESS,
  GET_Countries_SUCCESS,
  GET_Countries,
  GET_RM_LIST,
  GET_RM_LIST_SUCCESS,
  RmListMdmsType,
  nationaliyType,
  GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS,
  GET_DISTRIBUTORS_FOR_FILTERS,
  GET_AMCADMINTEMPLATE_SUCCESS,
  GET_AMCADMINTEMPLATE,
  GET_AIFAPPROVERTEMPLATE_SUCCESS,
  GET_AIFAPPROVERTEMPLATE,
  GET_IMTEMPLATE_SUCCESS,
  GET_IMTEMPLATE,
  GET_TRUSTEETEMPLATE_SUCCESS,
  GET_TRUSTEETEMPLATE,
  GET_POAAPPROVERTEMPLATE_SUCCESS,
  GET_POAAPPROVERTEMPLATE,
  GET_AUTHORISEDSIGNATORYTEMPLATE_SUCCESS,
  GET_AUTHORISEDSIGNATORYTEMPLATE,
  GET_DISTRIBUTORRMTEMPLATE_SUCCESS,
  GET_DISTRIBUTORRMTEMPLATE,
  GET_COMPANYDISTRIBUTORTEMPLATE_SUCCESS,
  GET_COMPANYDISTRIBUTORTEMPLATE,
  GET_INDIVIDUALDISTRIBUTORTEMPLATE_SUCCESS,
  GET_INDIVIDUALDISTRIBUTORTEMPLATE,
  GET_RMTEMPLATE_SUCCESS,
  GET_RMTEMPLATE,
  GET_AMCAPPROVERTEMPLATE_SUCCESS,
  GET_AMCAPPROVERTEMPLATE,
  CREATE_LUMPSUM_PAYMENT_SUCCESS,
  CREATE_LUMPSUM_PAYMENT,
  GET_AVAILABLE_BANKS_SUCCESS,
  GET_AVAILABLE_BANKS,
  GET_PAYMENT_STATUS_SUCCESS,
  GET_PAYMENT_STATUS,
  togglerType,
  GET_TOGGLER_SUCCESS,
  GET_TOGGLER,
  DOWNLOAD_DISTRIBUTOR_TEMPLATE_SUCCESS,
  DOWNLOAD_DISTRIBUTOR_TEMPLATE,
  UPDATE_PAYMENT_TYPE_SUCCESS,
  UPDATE_PAYMENT_TYPE,
} from '../types/mdms';

export type Distributor = {
  id: number;
  userId: number;
  name: string;
  firstName?: string;
  type: string;
  buildingNo: string;
  streetName: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  arnCode: string;
  panNumber: string;
  isActive: boolean | null;
  amcId: number[];
  rmId: number;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    firstName: string | null;
    lastName: string | null;
    countryCode: string;
    phone: string;
    email: string;
    role: string;
    isActive: boolean;
    password: string | null;
  };
  subdistributorType: string;
  subdistributors?: SubDistributor[];
};

export type SubDistributor = Distributor & {
  distributors_RM_Code: string;
  supportSubdistributorId: string;
  supportSubdistributorDetails: supportSubdistibutorDetailsType;
  directSubdistributorsDetails: directDistrubutorType;
};

export type getDistributorsResponse = {
  userId: number;
  empCode: string;
  amcId: number;
  createdAt: string;
  updatedAt: string;
  address1: string;
  address2: string;
  address3: string;
  arnCode: string;
  id: number;
  panNumber: string;
  phone: string;
  role: string;
  firstName: string;
  distributors: Distributor[];
};

//To get distributors under RM
export const getDistributors =
  (params?: { isActive: boolean }) =>
  async (dispatch: any): Promise<getDistributorsResponse> => {
    const distributorsResponse = await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors-of-rm`,
        method: 'GET',
        types: [GET_DISTRIBUTOR_CODES_SUCCESS, GET_DISTRIBUTOR_CODES],
        params,
      },
    });
    return distributorsResponse as getDistributorsResponse;
  };
export const getDistributorsForSubdistributor =
  (params?: {
    isActive?: boolean;
    distributorId?: number;
    subdistributorType?: string;
    rmId?: number;
  }) =>
  async (dispatch: any): Promise<getDistributorsResponse> => {
    const distributorsResponse = await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors/filter`,
        method: 'POST',
        types: [GET_DISTRIBUTOR_CODES_SUCCESS, GET_DISTRIBUTOR_CODES],
        body: params,
      },
    });
    return distributorsResponse as getDistributorsResponse;
  };
export const getIFSCDetails =
  (ifscCode: string) =>
  async (dispatch: any): Promise<IfscType> => {
    const ifscResponse = await dispatch({
      [CALL_API]: {
        url: `/onboarding/ifsc/${ifscCode}`,
        method: 'GET',
        types: [GET_IFSC_DETAILS_SUCCESS, GET_IFSC_DETAILS],
        slient: true,
      },
    });
    return ifscResponse as IfscType;
  };

//To get all the distributors list who's status is active
export const getDistributorsList =
  () =>
  async (dispatch: any): Promise<Distributor[]> => {
    const distributorsResponse = (await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors`,
        method: 'GET',
        types: [GET_DISTRIBUTORS_SUCCESS, GET_DISTRIBUTORS],
      },
    })) as Distributor[];
    return distributorsResponse as Distributor[];
  };

// Get the list of RMs under and return all the active rms

export type RMListFilter = {
  name: string;
  limit?: number;
  page?: number;
  orderBy?: string;
  orderDirection?: string;
};
export const getRMsList =
  (params?: RMListFilter) =>
  async (dispatch: any): Promise<RMType[]> => {
    const rmListRes = (await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/rm-list`,
        method: 'GET',
        types: [GET_RMS, GET_RMS_SUCCESS],
        params,
      },
    })) as { rms: RMType[]; limit: 10; page: 1; pages: 1; total: 1 };
    return rmListRes.rms as RMType[];
  };

export const getNationalityList =
  () =>
  async (dispatch: any): Promise<nationaliyType> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/default-countries.json',
        method: 'GET',
        types: [GET_Countries_SUCCESS, GET_Countries],
      },
    });
  };

// Get the RM list from MDMS (used in the Direct channel flow)
export const getRmList =
  () =>
  async (dispatch: any): Promise<RmListMdmsType[]> => {
    return (await dispatch({
      [CALL_API]: {
        url: '/mdms/rm_list.json',
        method: 'GET',
        types: [GET_RM_LIST_SUCCESS, GET_RM_LIST],
      },
    })) as unknown as RmListMdmsType[];
  };

export const getDistributorsListForFilters =
  (params?: { type?: string; isActive?: boolean }) =>
  async (dispatch: any): Promise<Distributor[]> => {
    const distributorsResponse = (await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/distributors/list`,
        method: 'GET',
        types: [GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS, GET_DISTRIBUTORS_FOR_FILTERS],
        params,
      },
    })) as Distributor[];
    return distributorsResponse as Distributor[];
  };

export const rmTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/rm.xlsx',
        method: 'GET',
        types: [GET_RMTEMPLATE_SUCCESS, GET_RMTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const individualDistributorTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/distributor_individual.xlsx',
        method: 'GET',
        types: [GET_INDIVIDUALDISTRIBUTORTEMPLATE_SUCCESS, GET_INDIVIDUALDISTRIBUTORTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const companyDistributorTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/distributor_company.xlsx',
        method: 'GET',
        types: [GET_COMPANYDISTRIBUTORTEMPLATE_SUCCESS, GET_COMPANYDISTRIBUTORTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const distributorRMTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/distributor_rm.xlsx',
        method: 'GET',
        types: [GET_DISTRIBUTORRMTEMPLATE_SUCCESS, GET_DISTRIBUTORRMTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const authorisedSignatoryTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/authorised_signatory.xlsx',
        method: 'GET',
        types: [GET_AUTHORISEDSIGNATORYTEMPLATE_SUCCESS, GET_AUTHORISEDSIGNATORYTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const poaApproverTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/poa_approver.xlsx',
        method: 'GET',
        types: [GET_POAAPPROVERTEMPLATE_SUCCESS, GET_POAAPPROVERTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const trusteeTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/trustee.xlsx',
        method: 'GET',
        types: [GET_TRUSTEETEMPLATE_SUCCESS, GET_TRUSTEETEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const investmentManagerTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/fund_manager.xlsx',
        method: 'GET',
        types: [GET_IMTEMPLATE_SUCCESS, GET_IMTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const rtaApproverTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/rta_approver.xlsx',
        method: 'GET',
        types: [GET_AIFAPPROVERTEMPLATE_SUCCESS, GET_AIFAPPROVERTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const amcApproverTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/aif_approver.xlsx',
        method: 'GET',
        types: [GET_AMCAPPROVERTEMPLATE_SUCCESS, GET_AMCAPPROVERTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const amcAdminTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/amc_admin.xlsx',
        method: 'GET',
        types: [GET_AMCADMINTEMPLATE_SUCCESS, GET_AMCADMINTEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const updatePaymentType =
  (body: any) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/update-payment-type`,
        method: 'POST',
        types: [UPDATE_PAYMENT_TYPE_SUCCESS, UPDATE_PAYMENT_TYPE],
        body,
      },
    });
  };

export const createLumpsumPayment =
  (body: any) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-payments/lumpsum/create-payment`,
        method: 'POST',
        types: [CREATE_LUMPSUM_PAYMENT_SUCCESS, CREATE_LUMPSUM_PAYMENT],
        body,
      },
    });
  };

export const getAvailableBanks =
  (body: Record<string, any>) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-payments/get-available-banks`,
        method: 'POST',
        types: [GET_AVAILABLE_BANKS_SUCCESS, GET_AVAILABLE_BANKS],
        body,
      },
    });
  };

export const getPaymentStatus =
  (orderId: string) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-payments/get-payment-status/${orderId}`,
        method: 'GET',
        types: [GET_PAYMENT_STATUS_SUCCESS, GET_PAYMENT_STATUS],
      },
    });
  };

export const featureToggles =
  () =>
  async (dispatch: any): Promise<togglerType> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/toggler.json',
        method: 'GET',
        types: [GET_TOGGLER_SUCCESS, GET_TOGGLER],
      },
    });
  };

export const downloadDistributorTemplate =
  () =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/excel-templates/distributor_excel.xlsx',
        method: 'GET',
        types: [DOWNLOAD_DISTRIBUTOR_TEMPLATE_SUCCESS, DOWNLOAD_DISTRIBUTOR_TEMPLATE],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
